/**
 * TripRealtimeRoute - Route-level wrapper that mounts TripRealtimeProvider
 * using the `:id` route param, so page components (and the data hooks they
 * call, e.g. useTripMembers/usePolls) are genuine descendants of the
 * provider and can consume it via useTripRealtimeSubscribe.
 *
 * A provider rendered *by* a page around its own JSX would not work here —
 * useContext only sees providers from actual ancestor components, and a
 * page's own top-level hook calls run before its own returned JSX mounts.
 * Wrapping at the route level sidesteps that entirely.
 */

import type { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { TripRealtimeProvider } from '../../contexts/TripRealtimeContext';

export default function TripRealtimeRoute({ children }: { children: ReactNode }) {
  const { id } = useParams<{ id: string }>();
  if (!id) return <>{children}</>;
  return <TripRealtimeProvider tripId={id}>{children}</TripRealtimeProvider>;
}
